function autoPlayYouTubeModal() {
    // Łapiemy i BS4, i BS5
    var triggers = jQuery("body").find('[data-toggle="modal"], [data-bs-toggle="modal"]');

    triggers.on("click", function (e) {
        e.preventDefault();

        var $trigger = jQuery(this);

        // BS4: data-target, BS5: data-bs-target
        var theModal = $trigger.data("target") || $trigger.data("bs-target");
        var videoSRC = $trigger.attr("data-theVideo"); // <- ZOSTAJE data-theVideo

        if (!theModal || !videoSRC) {
            return; // ignoruj inne modalowe przyciski
        }

        var sep = videoSRC.indexOf("?") === -1 ? "?" : "&";
        var videoSRCauto = videoSRC + sep + "autoplay=1";

        jQuery(theModal + " iframe").attr("src", videoSRCauto);

        jQuery(theModal)
            .off("hide.bs.modal.autoVideo")
            .on("hide.bs.modal.autoVideo", function () {
                jQuery(theModal + " iframe").attr("src", "");
            });
    });
}

jQuery(document).ready(function () {
    autoPlayYouTubeModal();
});